import '../css/styles.css';

/* Main Website JS */
// Modules
import MobileMenu from './modules/MobileMenu';
import Testimonials from './modules/testimonials';
import StickyHeader from './modules/StickyHeader';
import Timeline from './modules/timeline';
import SelectList from './modules/selectlist';
import QuoteForm from './modules/quote_form';
import RevealOnScroll from './modules/RevealOnScroll';
import Process from './modules/process';
import './modules/team-members';
import './modules/accordion-list';
/*
 To include FONTAWESOME in the project
 1. include the icon library required
 2. add each one from their respective lib
 3. then add their names to the lib call
 4. add usual <i> tag call in php or html element
*/
import {
	library,
	dom
} from '@fortawesome/fontawesome-svg-core'
// Import solid weight icons
import {
	faUser as fasUser,
	faCheck,
	faMobileAlt,
	faCalendarAlt as fasCalendar,
	faUserCircle as fasUserCircle,
	faWifi,
	faChartLine,
	faTrafficLight,
	faUsers,
	faConciergeBell,
	faTools,
	faPenFancy,
	faBullhorn,
	faMapMarkerAlt
} from '@fortawesome/free-solid-svg-icons'
// Import regular weight icons
import {
	faUser as farUser,
	faUserCircle as farUserCircle,
	faHeart as farHeart,
	faComment,
	faCopyright,
	faEnvelope,
	faCopy
} from '@fortawesome/free-regular-svg-icons'
// Import brand icons
import {
	faXTwitter as fabXTwitter,
	faFacebookF as fabFacebookF,
	faYoutube as fabYoutube,
	faPinterestP as fabPinterestP,
	faLinkedinIn as fabLinkedinIn,
	faInstagram as fabInstagram
} from '@fortawesome/free-brands-svg-icons';
// Add icons to library
// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
library.add(
	// Solid
	fasUser,
	faCheck,
	faMobileAlt,
	fasCalendar,
	fasUserCircle,
	farHeart,
	faWifi,
	faChartLine,
	faTrafficLight,
	faUsers,
	faConciergeBell,
	faTools,
	faPenFancy,
	faBullhorn,
	faMapMarkerAlt,
	// Regular
	farUser,
	faCheck,
	farUserCircle,
	faComment,
	faCopyright,
	faEnvelope,
	faCopy,
	// Brands to use icons with - ie. fa-Linked-in, need to remove dashes adn replace with capitals
	fabXTwitter,
	fabFacebookF,
	fabYoutube,
	fabPinterestP,
	fabLinkedinIn,
	fabInstagram
);
// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.watch();

const homepage = document.querySelector('.home');
if (homepage !== null) {
	new RevealOnScroll(document.querySelectorAll(".steelsasquatch_process .container"), 60);
	new RevealOnScroll(document.querySelectorAll(".split-content.active .split-content__image"), 80);
	new RevealOnScroll(document.querySelectorAll(".split-content.active .split-content__text_wrap"), 90);
	new RevealOnScroll(document.querySelectorAll(".testimonials"), 80);
}

const service = document.querySelector('.Accordion_wrapper');
if (service !== null) {
	new RevealOnScroll(document.querySelectorAll(".Accordion_wrapper"), 50);
}

const gettouch = document.querySelector('.get-in-touch');
if (gettouch !== null) {
	new RevealOnScroll(document.querySelectorAll(".get-in-touch h2"), 80);
}

// Global Functionality
new StickyHeader();
let mobileMenu = new MobileMenu();


/* if (window.page === 'get-a-quote') {
	QuoteForm();
}; */

//to add jquery to any page etc
//this looks for a class name in the boy tag to see if it should load jQuery
const use_jQuery = document.querySelector('.use_jQuery');
if (use_jQuery !== null) {

}
//import "jquery";

// back-to-top
// Set a variable for our button element.
const ToTopButton = document.getElementById('js-top');

// Let's set up a function that shows our scroll-to-top button if we scroll beyond the height of the initial window.
const scrollFunc = () => {
	// Get the current scroll value
	let windowheight = window.scrollY;

	// If the scroll value is greater than the window height, let's add a class to the scroll-to-top button to show it!
	if (windowheight > 500) {
		ToTopButton.className = 'back_to_top show';
	} else {
		ToTopButton.className = 'back_to_top hide';
	}
};

window.addEventListener('scroll', scrollFunc);

// When the button is clicked, run our ScrolltoTop function above!
ToTopButton.onclick = function (e) {
	e.preventDefault();
	document.body.scrollTop = 0;
	document.documentElement.scrollTop = 0;
};

/* Copy single post link 06052026 */
const copyLinkButtons = document.querySelectorAll('.js-copy-link');

if (copyLinkButtons.length) {
	copyLinkButtons.forEach((button) => {
		button.addEventListener('click', () => {
			const url = button.getAttribute('data-copy-url');
			const label = button.querySelector('span');

			if (!url || !label) {
				return;
			}

			const originalText = label.textContent;

			const showCopiedState = () => {
				label.textContent = 'Copied';

				setTimeout(() => {
					label.textContent = originalText;
				}, 1600);
			};

			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(url).then(() => {
					showCopiedState();
				});
			} else {
				const textarea = document.createElement('textarea');
				textarea.value = url;
				textarea.style.position = 'fixed';
				textarea.style.left = '-9999px';
				document.body.appendChild(textarea);
				textarea.focus();
				textarea.select();

				try {
					document.execCommand('copy');
					showCopiedState();
				} catch (error) {
					console.warn('Copy link failed:', error);
				}

				document.body.removeChild(textarea);
			}
		});
	});
}

/*
 Reference for the GDPR Cookie Consent
 https://closte.com/blog/wordpress-gdpr-cookie-plugins
 https://passatgt.github.io/gdpr-cookie-notice/
 https://github.com/passatgt/gdpr-cookie-notice
*/
//COOKIE FUNCTION
! function (e) {
	var o = !1;
	if ("function" == typeof define && define.amd && (define(e), o = !0), "object" == typeof exports && (module.exports = e(), o = !0), !o) {
		var t = window.Cookies,
			n = window.Cookies = e();
		n.noConflict = function () {
			return window.Cookies = t, n
		}
	}
}(function () {
	function k() {
		for (var e = 0, o = {}; e < arguments.length; e++) {
			var t = arguments[e];
			for (var n in t) o[n] = t[n]
		}
		return o
	}
	return function e(p) {
		function f(e, o, t) {
			var n;
			if ("undefined" != typeof document) {
				if (1 < arguments.length) {
					if ("number" == typeof (t = k({
							path: "/"
						}, f.defaults, t)).expires) {
						var i = new Date;
						i.setMilliseconds(i.getMilliseconds() + 864e5 * t.expires), t.expires = i
					}
					t.expires = t.expires ? t.expires.toUTCString() : "";
					try {
						n = JSON.stringify(o), /^[\{\[]/.test(n) && (o = n)
					} catch (e) {}
					o = p.write ? p.write(o, e) : encodeURIComponent(String(o)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), e = (e = (e = encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
					var c = "";
					for (var a in t) t[a] && (c += "; " + a, !0 !== t[a] && (c += "=" + t[a]));
					return document.cookie = e + "=" + o + c
				}
				e || (n = {});
				for (var r = document.cookie ? document.cookie.split("; ") : [], s = /(%[0-9A-Z]{2})+/g, d = 0; d < r.length; d++) {
					var l = r[d].split("="),
						m = l.slice(1).join("=");
					this.json || '"' !== m.charAt(0) || (m = m.slice(1, -1));
					try {
						var u = l[0].replace(s, decodeURIComponent);
						if (m = p.read ? p.read(m, u) : p(m, u) || m.replace(s, decodeURIComponent), this.json) try {
							m = JSON.parse(m)
						} catch (e) {}
						if (e === u) {
							n = m;
							break
						}
						e || (n[u] = m)
					} catch (e) {}
				}
				return n
			}
		}
		return (f.set = f).get = function (e) {
			return f.call(f, e)
		}, f.getJSON = function () {
			return f.apply({
				json: !0
			}, [].slice.call(arguments))
		}, f.defaults = {}, f.remove = function (e, o) {
			f(e, "", k(o, {
				expires: -1
			}))
		}, f.withConverter = e, f
	}(function () {})
}), window["gdpr-cookie-notice-templates"] = {}, window["gdpr-cookie-notice-templates"]["bar.html"] = '<div class="gdpr-cookie-notice">\n  <p class="gdpr-cookie-notice-description">{description}</p>\n  <nav class="gdpr-cookie-notice-nav">\n    <a href="#" class="gdpr-cookie-notice-nav-item gdpr-cookie-notice-nav-item-settings">{settings}</a>\n    <a href="#" class="gdpr-cookie-notice-nav-item gdpr-cookie-notice-nav-item-accept gdpr-cookie-notice-nav-item-btn">{accept}</a>\n  </nav>\n</div>\n', window["gdpr-cookie-notice-templates"]["category.html"] = '<li class="gdpr-cookie-notice-modal-cookie">\n  <div class="gdpr-cookie-notice-modal-cookie-row">\n    <h3 class="gdpr-cookie-notice-modal-cookie-title">{title}</h3>\n    <input type="checkbox" name="gdpr-cookie-notice-{prefix}" checked="checked" id="gdpr-cookie-notice-{prefix}" class="gdpr-cookie-notice-modal-cookie-input">\n    <label class="gdpr-cookie-notice-modal-cookie-input-switch" for="gdpr-cookie-notice-{prefix}"></label>\n  </div>\n  <p class="gdpr-cookie-notice-modal-cookie-info">{desc}</p>\n</li>\n', window["gdpr-cookie-notice-templates"]["modal.html"] = '<div class="gdpr-cookie-notice-modal">\n  <div class="gdpr-cookie-notice-modal-content">\n    <div class="gdpr-cookie-notice-modal-header">\n      <h2 class="gdpr-cookie-notice-modal-title">{settings}</h2>\n      <button type="button" class="gdpr-cookie-notice-modal-close"></button>\n    </div>\n    <ul class="gdpr-cookie-notice-modal-cookies"></ul>\n    <div class="gdpr-cookie-notice-modal-footer">\n      <a href="#" class="gdpr-cookie-notice-modal-footer-item gdpr-cookie-notice-modal-footer-item-statement">{statement}</a>\n      <a href="#" class="gdpr-cookie-notice-modal-footer-item gdpr-cookie-notice-modal-footer-item-save gdpr-cookie-notice-modal-footer-item-btn"><span>{save}</span></a>\n    </div>\n  </div>\n</div>\n';
var gdprCookieNoticeLocales = {};

function gdprCookieNotice(c) {
	var n = "gdprcookienotice",
		a = "gdpr-cookie-notice",
		r = window[a + "-templates"],
		i = Cookies.noConflict(),
		s = !1,
		d = !1,
		l = !1,
		m = ["performance", "analytics", "marketing"];
	c.locale || (c.locale = "en"), c.timeout || (c.timeout = 500), c.domain || (c.domain = null), c.expiration || (c.expiration = 30), void 0 === gdprCookieNoticeLocales[c.locale] && (c.locale = "en");
	var u = i.getJSON(n),
		p = new CustomEvent("gdprCookiesEnabled", {
			detail: u
		});

	function f(e) {
		for (var o = !1, t = 0; t < m.length; t++)
			if (c[m[t]] && !e[m[t]])
				for (var n = 0; n < c[m[t]].length; n++) i.remove(c[m[t]][n]), o = !0;
		o ? g() : document.documentElement.classList.remove(a + "-loaded")
	}

	function k(e) {
		var o = {
			date: new Date,
			necessary: !0,
			performance: !0,
			analytics: !0,
			marketing: !0
		};
		if (e)
			for (var t = 0; t < m.length; t++) o[m[t]] = document.getElementById(a + "-cookie_" + m[t]).checked;
		i.set(n, o, {
			expires: c.expiration,
			domain: c.domain
		}), f(o), p = new CustomEvent("gdprCookiesEnabled", {
			detail: o
		}), document.dispatchEvent(p)
	}

	function e() {
		if (d) return !1;
		var e, o, t = v("bar.html");
		document.body.insertAdjacentHTML("beforeend", t), e = document.querySelectorAll("." + a + "-nav-item-settings")[0], o = document.querySelectorAll("." + a + "-nav-item-accept")[0], e.addEventListener("click", function (e) {
			e.preventDefault(), h()
		}), o.addEventListener("click", function (e) {
			e.preventDefault(), k()
		}), d = !0
	}

	function g() {
		e(), setTimeout(function () {
			document.documentElement.classList.add(a + "-loaded")
		}, c.timeout)
	}

	function v(e, t) {
		var o = r[e],
			n = gdprCookieNoticeLocales[c.locale];
		if (t ? t += "_" : t = "", !("string" == typeof o && n instanceof Object)) return !1;
		for (var i in n) return o.replace(/({([^}]+)})/g, function (e) {
			var o = e.replace(/{/, "").replace(/}/, "");
			return "prefix" == o ? t.slice(0, -1) : n[o] ? n[o] : n[t + o] ? n[t + o] : e
		})
	}

	function o() {
		if (s) return !1;
		var e = v("modal.html");
		document.body.insertAdjacentHTML("beforeend", e);
		var o = document.querySelector("." + a + "-modal-cookies");
		o.innerHTML += v("category.html", "cookie_essential");
		var t = document.querySelector("." + a + "-modal-cookie-input"),
			n = document.querySelector("." + a + "-modal-cookie-input-switch");
		n.innerHTML = gdprCookieNoticeLocales[c.locale].always_on, n.classList.add(a + "-modal-cookie-state"), n.classList.remove(a + "-modal-cookie-input-switch"), t.remove(), c.performance && (o.innerHTML += v("category.html", "cookie_performance")), c.analytics && (o.innerHTML += v("category.html", "cookie_analytics")), c.marketing && (o.innerHTML += v("category.html", "cookie_marketing")),
			function () {
				var e = document.querySelectorAll("." + a + "-modal-close")[0],
					o = document.querySelectorAll("." + a + "-modal-footer-item-statement")[0],
					t = document.querySelectorAll("." + a + "-modal-cookie-title"),
					n = document.querySelectorAll("." + a + "-modal-footer-item-save")[0];
				e.addEventListener("click", function () {
					return document.documentElement.classList.remove(a + "-show-modal"), !1
				}), o.addEventListener("click", function (e) {
					e.preventDefault(), window.location.href = c.statement
				});
				for (var i = 0; i < t.length; i++) t[i].addEventListener("click", function () {
					return this.parentNode.parentNode.classList.toggle("open"), !1
				});
				n.addEventListener("click", function (e) {
					e.preventDefault(), n.classList.add("saved"), setTimeout(function () {
						n.classList.remove("saved")
					}, 1e3), k(!0)
				})
			}(), u && (document.getElementById(a + "-cookie_performance").checked = u.performance, document.getElementById(a + "-cookie_analytics").checked = u.analytics, document.getElementById(a + "-cookie_marketing").checked = u.marketing), s = !0
	}

	function h() {
		o(), document.documentElement.classList.add(a + "-show-modal")
	}
	u ? (f(u), document.dispatchEvent(p)) : (g(), c.implicit && window.addEventListener("scroll", function e() {
		var o, t, n, i, c;
		o = window.innerHeight || (document.documentElement || document.body).clientHeight, c = document, t = Math.max(c.body.scrollHeight, c.documentElement.scrollHeight, c.body.offsetHeight, c.documentElement.offsetHeight, c.body.clientHeight, c.documentElement.clientHeight), n = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop, i = t - o, 25 < Math.floor(n / i * 100) && !l && (l = !0) && (k(), window.removeEventListener("click", e))
	}));
	var t = document.querySelectorAll("." + a + "-settings-button");
	if (t)
		for (var y = 0; y < t.length; y++) t[y].addEventListener("click", function (e) {
			e.preventDefault(), h()
		})
}
gdprCookieNoticeLocales.en = {
	description: "We use cookies to offer you a better browsing experience, personalise content and ads, to provide social media features and to analyse our traffic. Read about how we use cookies and how you can control them by clicking Cookie Settings.",
	settings: "Cookie Settings",
	accept: "Accept Cookies",
	statement: "Our Cookie Statement",
	save: "Save Settings",
	always_on: "Always On",
	cookie_essential_title: "Essential Website Cookies",
	cookie_essential_desc: "Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.",
	cookie_performance_title: "Performance Cookies",
	cookie_performance_desc: "These cookies are used to enhance the performance and functionality of our websites but are non-essential to their use. For example it stores your preferred language or the region that you are in.",
	cookie_analytics_title: "Analytics Cookies",
	cookie_analytics_desc: "We use analytics cookies to help us measure how users interact with website content, which helps us customize our websites and application for you in order to enhance your experience.",
	cookie_marketing_title: "Marketing Cookies",
	cookie_marketing_desc: "These cookies are used to make advertising messages more relevant to you and your interests. The intention is to display ads that are relevant and engaging for the individual user and thereby more valuable for publishers and third party advertisers."
};

/*
The GDPR COOKIE CONSENT
https://github.com/passatgt/gdpr-cookie-notice
https://passatgt.github.io/gdpr-cookie-notice/
https://closte.com/blog/wordpress-gdpr-cookie-plugins
the script to run this is added above the bundle script in the footer
*/
gdprCookieNotice({
	locale: 'en', //This is the default value
	timeout: 500, //Time until the cookie bar appears
	expiration: 30, //This is the default value, in days
	//domain: '.nold.io', //If you run the same cookie notice on all subdomains, define the main domain starting with a .
	implicit: false, //Accept cookies on scroll
	statement: '/privacy-policy', //Link to your cookie statement page
	performance: ['JSESSIONID'], //Cookies in the performance category.
	analytics: ['_ga', '_gid', '_gat'], //ga Cookies in the analytics category.
	marketing: [] //SSID Cookies in the marketing category.
});


/* TODO ROBIN
You will need to wrap any external services JavaScript codes within a simple code. Below is how we made our Google Analytics and Facebook Pixel JavaScript:
Need to add reference yo al cookie script under the categories listed in the GDPR cookie consent modal
*/
document.addEventListener('gdprCookiesEnabled', function (e) {
	if (e.detail.analytics) {
		// paste Google Analytics code or similar services
		console.log('analytics cookies are enabled');
	}
	if (e.detail.performance) {
		console.log('performance cookies are enabled');
	}
	if (e.detail.marketing) {
		console.log('marketing cookies are enabled');
	}
});
